module.exports = __webpack_public_path__ + "static/media/circle-alert-v2.4e434670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/circle-alert-v2.svg
// module id = 791
// module chunks = 0